import type { QueryClient } from '@tanstack/react-query';

import { execute } from '@/graphql/execute';
import { analysisRunInputQuery } from '@/queries/analysisRuns.query';

/**
 * A past run's `inputJson`, or null when it cannot be read. One cache entry
 * per job, shared by the hub's re-run (`useOpenAnalysisRerun`), the details
 * drawer (`useAnalysisRunDetails`) and the station dock's re-run.
 */
export async function fetchAnalysisRunInput(queryClient: QueryClient, jobId: string): Promise<unknown> {
  try {
    const data = await queryClient.fetchQuery({
      queryKey: ['analysisRunInput', jobId],
      queryFn: () => execute(analysisRunInputQuery, { jobId }),
      staleTime: 5 * 60_000,
    });
    return data.analysisRunInput ?? null;
  } catch {
    return null;
  }
}
